import React from 'react';
import SitebarDropdown from './sitebarDropdown';
import i18n from 'src/utils/translate';
import styled from 'styled-components';
import { textLinkSecondary } from 'styles-js/mixins/typography';
import { LinkButton } from 'styles-js/buttons';

const UserMenuButton = styled(LinkButton)`
  ${textLinkSecondary};
  font-family: ${({theme}) => theme.fontFamilyTitle};
  line-height: 49px;
  display: flex;
  align-items: center;
  margin-left: 15px;

  &:focus, &:hover, &:active {
    color: ${({theme}) => theme.colorBlack};
  }
`;

const Avatar = styled.img`
  margin-right: 5px;
`;

const DropdownItemIcon = styled.span`
  margin-right: 15px;
  font-size: 17px;
`;

class UserMenu extends React.Component {
  onLogoutClick = (event) => {
    event.preventDefault();
    this.props.logout();
  }

  onHelpClick = (event) => {
    event.preventDefault();
    window.HelpscoutBeacon.triggerHelpScoutBeacon('USER_SUPPORT');
  }

  getMenuItems = () => {
    const { user } = this.props;
    const userName = user.username;
    return [
      {name: i18n.t('Profile'), icon: 'icon-profile-1', link: `/user/${userName}`},
      {name: i18n.t('Find people near me'), icon: 'icon-people', link: '/people-near-me'},
      {name: i18n.t('Your needs'), icon: 'icon-newsfeed', link: '/your-needs'},
      {name: i18n.t('Settings'), icon: 'icon-settings', link: '/settings'},
      {name: i18n.t('Email notifications'), icon: 'icon-mail-1', link: '/email-notifications'},
      {name: i18n.t('Help'), icon: 'icon-help', link: '#', onClick: this.onHelpClick},
      {name: i18n.t('Log out'), icon: 'icon-logout', link: '/', onClick: this.onLogoutClick},
    ];
  }

  render() {
    const { user, open, handleClick } = this.props;
    const avatarImageUrl = user.avatarImageUrl;
    const userName = user.username;

    return (
      <div data-test-id="user-menu">
        <UserMenuButton onClick={handleClick}>
          <Avatar alt={userName} className="avatar avatar--xsmall"
            src={avatarImageUrl} />
          {i18n.t('More')}
        </UserMenuButton>
        <SitebarDropdown marginLeft={-167} open={open}
          width={215}>
          <ul>
            {this.getMenuItems().map(item =>
              <li key={item.icon} onClick={item.onClick}>
                <a href={item.link} target={item.target}>
                  <DropdownItemIcon className={item.icon} />
                  {item.name}{' '}
                </a>
              </li>,
            )}
          </ul>
        </SitebarDropdown>
      </div>
    );
  }
}

export default UserMenu;
